"use client";

import { Box, HStack } from "@chakra-ui/react";
import { motion } from "framer-motion";

export default function ChatBotWaitingAnimation() {
  return (
    <HStack alignSelf="flex-start" spaceX={2}>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ repeat: Infinity, duration: 1 }}
      >
        <HStack>
          <Box
            w="2"
            h="2"
            bg="moveon.primary"
            borderRadius="full"
            // @ts-ignore This works but Chakra/TS complains
            animation="bounce 1s infinite"
          />
          <Box
            w="2"
            h="2"
            bg="moveon.secondary"
            borderRadius="full"
            // @ts-ignore This works but Chakra/TS complains
            animation="bounce 1s infinite 0.2s"
          />
          <Box
            w="2"
            h="2"
            bg="moveon.tertiary"
            borderRadius="full"
            // @ts-ignore This works but Chakra/TS complains
            animation="bounce 1s infinite 0.4s"
          />
        </HStack>
      </motion.div>
    </HStack>
  );
}
